// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"293":"component---src-pages-index-js","653":"component---src-pages-case-study-minee-wipes-js"}[chunkId] || chunkId) + "-" + {"293":"81f5b9506784af49e120","522":"4b42accb5613890320a2","653":"232f53cbfaa0b7c3a7ca"}[chunkId] + ".js";
};